










import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { AuthService } from '@/modules/user/services/auth.service'

@Component({
  inheritAttrs: false,
  components: { BaseButton }
})
export default class UserProfileMailButton extends Vue {
  constructor(
    private readonly service: AuthService
  ) {
    super()
  }

  @Prop() mail!: string
  @Prop({ default: 'تایید ایمیل' }) label!: string
  loading = false

  sendEmailVerification() {
    this.loading = true
    this.service.resendEmailVerification().onFinish(() => {
      this.loading = false
    })
  }

}
